import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { ClerkProviderWithRouter } from './auth/ClerkProviderWithRouter';
import { App } from './App';

import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import './styles/dash.css';
import './styles/crm.css';

/* A tab left open across a deploy can ask for a lazy chunk (the Twilio SDK)
   that the new build renamed. Vite reports that here; a reload gets the
   matching set rather than a broken phone. */
window.addEventListener('vite:preloadError', (e) => { e.preventDefault(); window.location.reload(); });

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ClerkProviderWithRouter>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </ClerkProviderWithRouter>
    </BrowserRouter>
  </StrictMode>,
);
